import { DropdownOption } from 'components/Dropdown';
import dayjs from 'dayjs';

export const getStartEndDates = (selectedOption: DropdownOption) => {
  const startDate = dayjs().subtract(parseInt(selectedOption.value), 'day');
  const endDate = dayjs();
  return { startDate, endDate };
};
